import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

// import JS files
import MuiDrawer from "../../shares/mui/MuiDrawer";

// import others files
import "../../../styles/navbar.css";
import logo from "../../../assets/imgs/logo.svg";
import telegramIcon from "../../../assets/imgs/telegram.svg";
import twitterIcon from "../../../assets/imgs/twitter.svg";
import instagramIcon from "../../../assets/imgs/instagram.svg";

const menuItems = [
  { labelFa: "صفحه اصلی", labelEn: "homepage", route: "/homepage" },
  { labelFa: "اخبار", labelEn: "news", route: "/news-list" },
  { labelFa: "دیدگاه‌ها", labelEn: "persons", route: "/opinion-list" },
  { labelFa: "چندرسانه‌ای", labelEn: "media", route: "/media-list" },
  { labelFa: "درباره‌ما", labelEn: "aboutus", route: "/about-us" },
  { labelFa: "تماس با ما", labelEn: "contactus", route: "/contact-us" },
];

const Navbar = (props) => {
  const navigate = useNavigate();

  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = () => {
    setOpenDrawer((before) => !before);
  };

  return (
    <>
      {/* Desktop Navbar */}
      <div className="hidden md:grid grid-cols-12 items-center shadow-md py-4 px-8 2xl:px-32">
        <div className=" col-span-3">
          <img
            className="cursor-pointer"
            src={logo}
            onClick={() => navigate("/")}
          />
        </div>
        <div className="flex justify-between items-center col-span-6 ">
          {menuItems.map((item, index) => {
            return (
              <div
                onClick={() => navigate(item.route)}
                className={
                  props.active_item == item.labelEn
                    ? "navbar-item-active"
                    : "navbar-item"
                }
              >
                <span className="">{item.labelFa}</span>
              </div>
            );
          })}
        </div>
        <div className=" col-span-3">
          <img
            className="cursor-pointer invisible"
            src={logo}
            onClick={() => navigate("/")}
          />
        </div>
      </div>
      {/* Mobile Navbar */}
      <div className="grid md:hidden grid-cols-6 shadow-lg px-4 py-4">
        <div className="col-span-1">
          <MenuIcon
            onClick={() => toggleDrawer()}
            fontSize="large"
            className="text-myblues-300 font-bold"
          />
        </div>
        <div className="col-span-4 flex justify-center">
          <img
            src={logo}
            className="w-32"
            onClick={() => navigate("/homepage")}
          />
        </div>
        <div className="col-span-1 "></div>
      </div>

      <MuiDrawer
        anchor="right"
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
      >
        <div className="w-screen">
          <div className="grid grid-cols-6 shadow-lg px-4 py-4">
            <div className="col-span-1"></div>
            <div className="col-span-4 flex justify-center">
              <img src={logo} className="w-32" />
            </div>
            <div
              onClick={() => toggleDrawer()}
              className="col-span-1 flex justify-end"
            >
              <div className="bg-mygrays-100 rounded-lg p-1 w-min">
                <CloseIcon className="text-myblues-300" />
              </div>
            </div>
          </div>
          {menuItems.map((item, index) => {
            return (
              <div className="border-b mx-4">
                <div
                  onClick={() => navigate(item.route)}
                  className={
                    props.active_item == item.labelEn
                      ? "m-navbar-item-active "
                      : "m-navbar-item"
                  }
                >
                  <span className="">{item.labelFa}</span>
                </div>
              </div>
            );
          })}
          <div className="bg-mygrays-100 mt-12 mx-8 p-4 rounded-lg flex justify-center items-center mb-4">
            <a
              target="_blank"
              href="https://instagram.com/moraghebbime?igshid=ODkwYmMyNzQ1NA=="
            >
              <img className="mx-4 w-8" src={instagramIcon} />
            </a>
            <a target="_blank" href="https://t.me/moraghebbime">
              <img className="mx-4 w-8" src={telegramIcon} />
            </a>
            <a>
              <img className="mx-4 w-8" src={twitterIcon} />
            </a>
          </div>
        </div>
      </MuiDrawer>
    </>
  );
};

export default Navbar;
